import { ROLES as R } from "../core/roles";
import { everyoneBut, lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const supportPermissions = {
  view: "support.view",
  nav: "support.nav",
  category: { manage: "support.category.manage", branchOnly: "support.category.branchOnly" },
  ticket: {
    manage: "support.ticket.manage",
    reply: "support.ticket.reply",
    delete: "support.ticket.delete",
    clientSide: "support.ticket.clientSide",
    filters: {
      hidden: "support.ticket.filters.hidden",
      statusPriorityOnly: "support.ticket.filters.statusPriorityOnly",
    },
  },
};

// A ticket belongs to one restaurant: the server populates `ticket.storeId.id` (public id),
// which is the identity the ticket permissions are checked against (NA-011). Categories are
// shared configuration with no restaurant, so they stay role-only.
const ticketScoped = (roles) => rule(roles, { scope: SCOPES.RESTAURANT });

export const supportGrants = {
  "support.view": rule([...everyoneBut(), R.NEW]),
  // feedus has no sidebar entry but can open the URL
  "support.nav": rule(lud(R.BRANCH, R.FA, R.MENU_SP, R.DM, R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  "support.category.manage": rule(lud(R.DMM)),
  // branch users only see their own category subset
  "support.category.branchOnly": rule([R.BRANCH]),
  // status, priority, assignment, close and internal notes
  "support.ticket.manage": ticketScoped(lud(R.AM, R.DMM)),
  // adding a message to a ticket: whoever can open the support page, for the ticket's own restaurant
  "support.ticket.reply": ticketScoped([...everyoneBut(), R.NEW]),
  "support.ticket.delete": ticketScoped(lud()),
  // restaurant / branch side of a ticket conversation (display classification, not scoped)
  "support.ticket.clientSide": rule([R.STORE, R.BRANCH, R.STORE_L, R.NEW]),
  // the Tickets page's own filter panel (display only; the ticket list is scoped by the server)
  "support.ticket.filters.hidden": rule([R.BRANCH]),
  "support.ticket.filters.statusPriorityOnly": rule([R.STORE, R.STORE_L]),
};
